import Button from 'assets/components/button/Button';
import ThemeButtonCircle from 'assets/components/button/themes/Theme.Button.Circle';
import Card from 'assets/components/card/Card';
import ThemeCardRow from 'assets/components/card/themes/Theme.Card.Row';
import Icon from 'assets/components/icon/Icon';
import Page from 'assets/components/page/Page';
import ThemePageSplit from 'assets/components/page/themes/Theme.Page.Split';
import { getLocales } from 'assets/locales/Locale';
import {
  ContractRefundAction,
  ContractRefundInfoTab,
  useContractRefundProvider,
} from '../Sales.ContractRefund.Hooks';
import SalesContractRefundInfoDocuments from './info/Sales.ContractRefund.Info.Documents';
import SalesContractRefundInfoGeneralInfo from './info/Sales.ContractRefund.Info.GeneralInfo';
import SalesContractRefundInfoNavigation from './info/Sales.ContractRefund.Info.Navigation';
import SalesContractRefundInfoNotes from './info/Sales.ContractRefund.Info.Notes';
import ContractRefundStatusCode from 'models/enums/ContractRefundStatusCode';

const SalesContractRefundInfo = () => {
  const { lang } = getLocales();
  const { selected, pageRouter, permissions, findApi } = useContractRefundProvider();

  return !selected ? null : (
    <Page
      class={ThemePageSplit}
      isLoading={findApi?.isExecuting}
      header={
        <Card
          class={ThemeCardRow}
          media={<Icon class="if-database" />}
          info={selected?.statusCode ? lang[selected.statusCode]?.replace(/_/g, ' - ') : lang.noStatusDefined}
          title={selected?.jobId}
          description={<></>}
        />
      }
      sidebar={
        <>
          {(!pageRouter.query.infoTab || pageRouter.query.infoTab === ContractRefundInfoTab.INFO) && (
            <SalesContractRefundInfoGeneralInfo />
          )}
          {pageRouter.query.infoTab === ContractRefundInfoTab.DOCUMENTS && <SalesContractRefundInfoDocuments />}
          {pageRouter.query.infoTab === ContractRefundInfoTab.NOTES && <SalesContractRefundInfoNotes />}
        </>
      }
      render={<SalesContractRefundInfoNavigation />}
      footer={
        <>
          <Button
            class={ThemeButtonCircle}
            media={<Icon class="fas-credit-card" />}
            onClick={pageRouter.updateParams}
            render={lang.processRefund}
            data={{ id: selected.id.toString(), action: ContractRefundAction.PROCESS }}
            htmlElementProps={{
              title: lang.processRefund,
            }}
            disabled={!permissions?.EDIT_CONTRACTREFUND || selected?.statusCode !== ContractRefundStatusCode.OPEN}
          />
        </>
      }
    />
  );
};

export default SalesContractRefundInfo;
